import { Phone, Mail } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      data-testid="footer"
      className="bg-[#fff8ed] border-t border-black/5 py-16"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_fragrance-network/artifacts/kj0kcj9m_Logo%20Le%20Pschitt%20Franc%CC%A7ais.jpeg"
              alt="Le Pschitt Français"
              data-testid="footer-logo"
              className="h-24 w-auto object-contain rounded-md mb-4"
            />
            <p className="font-body text-sm font-light text-[#525252] leading-relaxed">
              Le parfum réinventé dans le quotidien. Distribution de fragrances
              via des diffuseurs intelligents dans des lieux premium.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-body text-sm tracking-[0.15em] uppercase text-[#0A0A0A] mb-4">
              Navigation
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="#probleme"
                  className="font-body text-sm text-[#525252] hover:text-[#B89F7C] transition-colors"
                >
                  Le Problème
                </a>
              </li>
              <li>
                <a
                  href="#solution"
                  className="font-body text-sm text-[#525252] hover:text-[#B89F7C] transition-colors"
                >
                  La Solution
                </a>
              </li>
              <li>
                <a
                  href="#tarifs"
                  className="font-body text-sm text-[#525252] hover:text-[#B89F7C] transition-colors"
                >
                  Tarifs
                </a>
              </li>
              <li>
                <a
                  href="#contact"
                  className="font-body text-sm text-[#525252] hover:text-[#B89F7C] transition-colors"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-body text-sm tracking-[0.15em] uppercase text-[#0A0A0A] mb-4">
              Contact
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="tel:+33650276753"
                  data-testid="footer-phone"
                  className="font-body text-sm text-[#525252] hover:text-[#B89F7C] transition-colors flex items-center gap-2"
                >
                  <Phone size={16} strokeWidth={1} />
                  +33 6 50 27 67 53
                </a>
              </li>
              <li>
                <a
                  href="mailto:hello@lepschittfrançais.fr"
                  data-testid="footer-email"
                  className="font-body text-sm text-[#525252] hover:text-[#B89F7C] transition-colors flex items-center gap-2"
                >
                  <Mail size={16} strokeWidth={1} />
                  hello@lepschittfrançais.fr
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-[#E5E5E5] pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-body text-xs text-[#525252]">
            © {currentYear} Le Pschitt Français. Tous droits réservés.
          </p>
          <p className="font-body text-xs text-[#525252]">
            Conçu avec élégance à Paris
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
